import "../styles/globals.css"
import "../styles/fonts.css"

import type { AppProps } from "next/app"
import Head from "next/head"
import { NuqsAdapter } from "nuqs/adapters/next/pages"
import PagesRouterAmplitudeSync from "../components/PagesRouterAmplitudeSync"
import { fontVariables } from "../styles/fonts"
// Records the landing on every full page load, before client-side navigation drops the query.
import "../utils/landing"

// If you're using a custom layout type, define it here
type NextPageWithLayout = {
  getLayout?: (page: React.ReactElement) => React.ReactNode
}

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout
}

export default function App({ Component, pageProps }: AppPropsWithLayout) {
  // If page layout is available, use it. Else return the page
  const getLayout = Component.getLayout || ((page: React.ReactElement) => page)
  return (
    <NuqsAdapter>
      <PagesRouterAmplitudeSync />
      <Head>
        <meta
          content="width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover"
          key="viewport"
          name="viewport"
        />
        <meta content="#FEFEF9" key="theme-color" name="theme-color" />
        <meta content="light" name="color-scheme" />
      </Head>
      <main className={fontVariables.join(" ")}>{getLayout(<Component {...pageProps} />)}</main>
    </NuqsAdapter>
  )
}
